import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/common-services/user.services';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-anynoumouse-container',
  templateUrl: './anynoumouse-container.component.html',
  styleUrls: ['./anynoumouse-container.component.css']
})
export class AnynoumouseContainerComponent {
  constructor(
    public userService:UserService,
    public languageService:LanguageService,
    public router: Router

  ){}

  isNotChangePassword() {
    if (this.router.url.indexOf('/authentication/change-password') > -1) {
      return false;
    }
    else {
      return true;
    }
  }
  onLanguageChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.languageService.switchLang(target.value);
  }
}
